import { render, staticRenderFns } from "./UserInputItemsTable.vue?vue&type=template&id=b200311e&scoped=true"
import script from "./UserInputItemsTable.vue?vue&type=script&lang=js"
export * from "./UserInputItemsTable.vue?vue&type=script&lang=js"
import style0 from "./UserInputItemsTable.vue?vue&type=style&index=0&id=b200311e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b200311e",
  null
  
)

export default component.exports